export enum UserRole {
    superAdmin = 0,
    admin = 1,
    user = 2,
    service = 3,
    tuner = 5
}
